import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1506_20146",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1506_20146)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.54934 17.6534L4.21484 12.3189L5.28384 11.2496L9.54934 15.5151L18.7148 6.34961L19.7838 7.41886L9.54934 17.6534ZM14.6493 21.0016C13.7737 20.1309 13.3358 19.0662 13.3358 17.8074C13.3358 16.5585 13.7737 15.4964 14.6493 14.6209C15.525 13.7452 16.5872 13.3074 17.8358 13.3074C19.0845 13.3074 20.1467 13.7452 21.0223 14.6209C21.898 15.4964 22.3358 16.5585 22.3358 17.8074C22.3358 19.0662 21.898 20.1309 21.0223 21.0016C20.1467 21.8721 19.0845 22.3074 17.8358 22.3074C16.5872 22.3074 15.525 21.8721 14.6493 21.0016ZM17.8358 20.5189C17.9692 20.5189 18.0827 20.472 18.1763 20.3784C18.2698 20.2849 18.3166 20.1714 18.3166 20.0381C18.3166 19.9048 18.2698 19.7913 18.1763 19.6976C18.0827 19.6041 17.9692 19.5574 17.8358 19.5574C17.7025 19.5574 17.5891 19.6041 17.4956 19.6976C17.4019 19.7913 17.3551 19.9048 17.3551 20.0381C17.3551 20.1714 17.4019 20.2849 17.4956 20.3784C17.5891 20.472 17.7025 20.5189 17.8358 20.5189ZM17.3936 18.5956H18.2781V15.0959H17.3936V18.5956Z",
			fill: "currentColor"
		})
	})]
});
export default SvgCheckAlert;
